<template>
  <!-- 车辆登记 -->
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="160px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class=" formItemBox">
          <el-form-item label="单位名称:" prop="companyName">
            <el-input  placeholder="" v-model="searchFrom.companyName"></el-input>
          </el-form-item>
          <el-form-item label="车牌号:" prop="vhcNo">
            <el-input  placeholder="" v-model="searchFrom.vhcNo"></el-input>
          </el-form-item>
          <el-form-item label="车辆品牌型号:" prop="vhcBrandModel">
            <el-input  placeholder="" v-model="searchFrom.vhcBrandModel"></el-input>
          </el-form-item>
          <el-form-item label="发动机型号:" prop="vhcEngineType">
            <el-input  placeholder="" v-model="searchFrom.vhcEngineType"></el-input>
          </el-form-item>
          <el-form-item label="VIN码:" prop="vhcVinNo">
            <el-input  placeholder="" v-model="searchFrom.vhcVinNo"></el-input>
          </el-form-item>
          <el-form-item label="排放阶段:" prop="standardsId">
            <el-select placeholder="请选择" v-model="searchFrom.standardsId">
              <el-option
                v-for="item in pfbz"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否加装污染控制装置:"    prop="isAddControl">
            <el-select placeholder="请选择" v-model="searchFrom.isAddControl">
              <el-option
                v-for="item in isList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否加装在线监控设备:"    prop="isAddOnlineControl">
            <el-select placeholder="请选择" v-model="searchFrom.isAddOnlineControl">
              <el-option
                v-for="item in isList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="燃料种类:" prop="energyType">
            <el-select placeholder="请选择" v-model="searchFrom.energyType">
              <el-option
                v-for="item in NYtype"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆归属单位:" prop="vhcTenantCompanyName">
            <el-input  placeholder="" v-model="searchFrom.vhcTenantCompanyName"></el-input>
          </el-form-item>
          <el-form-item label="车辆种类:" prop="vhcTypeName">
            <el-input  placeholder="" v-model="searchFrom.vhcTypeName"></el-input>
          </el-form-item>
          <el-form-item label="初次登记日期:" prop="firstDates">
            <el-date-picker
              v-model="searchFrom.firstDates"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>

        </div>
        <div class="searchBtnBox">
          <el-form-item btnCode="00BP007B001"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
           <el-form-item  >
            <el-button type="primary" btnCode="00BP007B001"  v-if="btnFlg[1]" @click="addVeicle">新增</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="modifyVeicle">修改</el-button>
          </el-form-item> -->
          <el-form-item  btnCode="00BP007B001"  v-if="btnFlg[2]">
            <el-button type="danger" @click="delVeicle">删除</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" btnCode="00BP007B001"  v-if="btnFlg[3]" @click="THimportFn()">车辆导入</el-button>
          </el-form-item>
          <el-form-item btnCode="00BP007B001"  v-if="btnFlg[3]">
            <el-button type="primary" @click="modelDown">模板下载</el-button>
          </el-form-item>
          <el-form-item btnCode="00BP007B006"  v-if="btnFlg[5]">
            <el-button type="primary" @click="exportFn">导出</el-button>
          </el-form-item>

          <!-- <el-form-item>
            <el-button type="primary" @click="takeGoods">导入</el-button>
          </el-form-item> -->
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' class="tableComent"
                @row-click="handleRowClick" height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
             <el-button type="text" size="mini"  btnCode="00BP007B001"  v-if="btnFlg[4]" @click="modifyVeicle(scope.row)">修改</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="vhcNo"  min-width="120" label="车牌号"></el-table-column>
        <el-table-column prop="vhcVinNo"  min-width="200" :show-overflow-tooltip="true" label="VIN码"></el-table-column>
        <el-table-column prop="vhcEngineNo"  min-width="200"  :show-overflow-tooltip="true" label="发动机号码"></el-table-column>
        <el-table-column prop="standardsName" width="80" :show-overflow-tooltip="true" label="排放阶段"></el-table-column>
        <el-table-column property="energyType" label="燃料种类" width="100" >
          <template scope="scope">
            <span v-if="scope.row.energyType!==null">{{["其他","******", "汽油","柴油", "气", "电" ,"乙醇" ,"氢能源"][scope.row.energyType+1]}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="firstDate" width="170" :formatter="dateFormat1" label="初次登记日期"></el-table-column>

        <el-table-column prop="vhcTypeName"  min-width="200"  :show-overflow-tooltip="true" label="车辆种类"></el-table-column>
        <el-table-column prop="companyName" min-width="260"  :show-overflow-tooltip="true" label="单位名称"></el-table-column>
        <el-table-column prop="vhcCompanyName"  min-width="260" :show-overflow-tooltip="true" label="车辆所有人名称"></el-table-column>
        <el-table-column prop="vhcBrandModel"  min-width="200" :show-overflow-tooltip="true" label="车辆品牌型号"></el-table-column>
        <el-table-column prop="vhcEngineType"  min-width="120" :show-overflow-tooltip="true" label="发动机型号"></el-table-column>
        <el-table-column property="isAddControl" width="100" label="是否加装污染控制装置" >
          <template scope="scope">
            {{[ "是", "否" ][scope.row.isAddControl-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="controlType"  width="100" :show-overflow-tooltip="true" label="污染控制装置种类"></el-table-column>
        <el-table-column property="isAddOnlineControl" width="100" label="是否加装在线监控设备" >
          <template scope="scope">
            {{[ "是", "否" ][scope.row.isAddOnlineControl-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="registerDate" width="160" :formatter="dateFormat1" label="出厂日期"></el-table-column>
        <el-table-column prop="weight"  width="100" :show-overflow-tooltip="true" label="车辆总质量"></el-table-column>
        <el-table-column property="isGreenChannel" width="140" label="是否建立绿色运输责任制和承诺制" >
          <template scope="scope">
            {{[ "是", "否" ][scope.row.isGreenChannel-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="vhcTenantCompanyName"  min-width="260" :show-overflow-tooltip="true" label="车辆归属单位"></el-table-column>
        <el-table-column prop="purposeName"  width="150" :show-overflow-tooltip="true" label="拉运货物名称"></el-table-column>
        <el-table-column property="vhcAging" label="车辆时效" >
          <template scope="scope">
            {{[ "长期", "临时" ][scope.row.vhcAging-1]}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="searchFrom.pageNo"
                     :page-sizes="[25,50,100]"
                     :page-size="searchFrom.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>

    <!-- 新建修改 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeDialog" width="1100px" center>
      <span>
         <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline yanzheng jiaoyan" label-width="160px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="inpBox">
               <el-form-item label="车牌号:" prop="vhcNo">
                <el-input  placeholder="" @blur="CPHfn()" :class="{ 'disabled': !isAdd }"  :readonly="!isAdd" v-model.trim="addFrom.vhcNo" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="车辆种类:" prop="vhcTypeName" >
                <el-input  placeholder="" v-model="addFrom.vhcTypeName"  maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="单位名称:" prop="companyName" >
                <el-input  placeholder="" v-model="addFrom.companyName"  maxlength="20"></el-input>
              </el-form-item>
               <el-form-item label="车辆所有人名称:" prop="vhcCompanyName" >
                <el-input  placeholder="" v-model="addFrom.vhcCompanyName"  maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="车辆品牌型号:" prop="vhcBrandModel" >
                <el-input  placeholder="" v-model="addFrom.vhcBrandModel"  maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="发动机型号:" prop="vhcEngineType" >
                <el-input  placeholder="" v-model="addFrom.vhcEngineType"  maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="发动机号码:" prop="vhcEngineNo" >
                <el-input  placeholder="" v-model="addFrom.vhcEngineNo"  maxlength="30"></el-input>
              </el-form-item>
               <el-form-item label="VIN码:" prop="vhcVinNo">
                <el-input  placeholder=""  maxlength="18" v-model="addFrom.vhcVinNo"></el-input>
              </el-form-item>
              <el-form-item label="排放阶段:"  prop="standards">
                <el-select placeholder="请选择" value-key="id"  v-model="addFrom.standards">
                  <el-option
                    v-for="item in pfbz"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="是否加装污染控制装置:"    prop="isAddControl">
                <el-select placeholder="请选择" v-model="addFrom.isAddControl">
                  <el-option
                    v-for="item in isList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="污染控制装置种类:" prop="controlType" >
                <el-input  placeholder="" v-model="addFrom.controlType"  maxlength="30"></el-input>
              </el-form-item>
               <el-form-item label="是否加装在线监控设备:"    prop="isAddOnlineControl">
                <el-select placeholder="请选择" v-model="addFrom.isAddOnlineControl">
                  <el-option
                    v-for="item in isList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="燃料种类:"  prop="energyType">
                <el-select placeholder="请选择" v-model="addFrom.energyType">
                  <el-option
                    v-for="item in NYtype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="出厂日期:" prop="registerDate">
                <el-date-picker
                  v-model="addFrom.registerDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
                </el-form-item>
                <el-form-item label="初次登记日期:" prop="firstDate">
                <el-date-picker
                  v-model="addFrom.firstDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
                </el-form-item>
              <el-form-item label="车辆总质量:" prop="weight">
                <el-input  placeholder="" v-model="addFrom.weight"  v-number-input.float="2" maxlength="11"></el-input>
              </el-form-item>

              <el-form-item label="车辆归属单位:" prop="vhcTenantCompanyName" >
                <el-input  placeholder="" v-model="addFrom.vhcTenantCompanyName"  maxlength="30"></el-input>
              </el-form-item>
               <!-- <el-form-item label="拉运货物名称:"  prop="purpose">
                <el-select placeholder="请选择" value-key="id"  filterable allow-create
                           default-first-option v-model="addFrom.purpose">
                  <el-option
                    v-for="item in clyt"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item> -->
              <el-form-item label="车辆时效:" prop="vhcAging">
                <el-select placeholder="请选择" v-model="addFrom.vhcAging">
                  <el-option
                    v-for="item in clsx"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="是否建立绿色运输责任制和承诺制:" label-width="230px"    prop="isGreenChannel">
                <el-select placeholder="请选择" v-model="addFrom.isGreenChannel">
                  <el-option
                    v-for="item in isList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>证件信息</span>
              </h4>
            </div>
            <div class="box">
              <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreview"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                   :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove" :class="[isAddImg?'hidden':'']">
                </el-upload>
                <h6>行驶证</h6>
              </div>
               <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg1"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreview1"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                   :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove1" :class="[isAddImg1?'hidden':'']">
                </el-upload>
                <h6>随车清单</h6>
              </div>

            </div>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>车辆照片</span>
              </h4>
              <div class="imgBox" style="margin-left:60px">
                <el-image
                  :src="carurl"
                  style="width: 383.77px; height: 237.78px"
                  :preview-src-list="getSrcList(index,[carurl])"
                  >
                </el-image>
            </div>
            </div>
           </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看图片" :visible.sync="lookImgVisible" center="">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <!-- 导入 -->
    <importC   v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { compressImage } from '@/utils/compressImage'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { CVRlist, CVRadd, cVIupdate, cVIdelete, cVLlist, cVTlist, cVPlist,
  cVElist, getCVehicleInfo, getRelationCustomerFleet, RimpVehicleInfoExcel } from '@/api/vgs-driver'
import importC from '@/components/import.vue'
export default {
  components: {
    importC
  },
  data () {
    return {
      carurl: '',
      h: '500px',
      total: 0,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      addFrom: {
      },
      importDialog: false,
      isAdd: false,
      title: '添加',
      vehicleL: [],
      vehicleT: [],
      clyt: [],
      pfbz: [],
      vhcType: {},
      vhcL: {},
      ids: [],
      rules: {
        vhcNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }//,
          // this.rule.vhcNo
        ],

        // companyName: [
        //   { required: true, message: '请输入单位名称', trigger: 'blur' }
        // ],
        vhcCompany1: [
          { required: true, message: '请输入所属个人', trigger: 'blur' }
        ],
        vhcEngineNo: [
          { required: true, message: '请输入发动机号码', trigger: 'blur' }
        ],
        standards: [
          { required: true, message: '请输入选择排放阶段', trigger: 'blur' }
        ],
        firstDate: [
          { required: true, message: '请选择初次登记日期', trigger: 'blur' }
        ],
        vhcVinNo: [
          { required: true, message: '请输入 VIN码', trigger: 'blur' }
        ],
        energyType: [
          { required: true, message: '请选择燃料种类', trigger: 'blur' }
        ]

      },
      dialogVisible: false,
      lookImgVisible: false,
      loading: 'false',
      isList: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '是'
        },
        {
          value: 2,
          label: '否'
        }
      ],
      NYtype: [
        { value: '', label: '请选择' },
        { value: 0, label: '******' },
        { value: -1, label: '其他' },
        { value: 1, label: '汽油' },
        { value: 2, label: '柴油' },
        { value: 3, label: '天然气' },
        { value: 4, label: '电' },
        { value: 5, label: '乙醇' },
        { value: 6, label: '氢能源' }
      ],
      cllx: [
        { value: '', label: '请选择' },
        { value: 1, label: '集港' },
        { value: 2, label: '外发' }
      ],
      clsx: [
        { value: '', label: '请选择' },
        { value: 1, label: '长期' },
        { value: 2, label: '临时' }
      ],
      ssdw: [],
      isAddImg: false,
      isAddImg1: false,
      listImg: [],
      listImg1: [],
      imgUrl: [],
      imgfile: new FormData(),
      dialogImageUrl: '',
      btnFlg: [],
      btnIdArr: [ '00BP007B001', '00BP007B002',
        '00BP007B003', '00BP007B004', '00BP007B005', '00BP007B006']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/vehicleRegister')
    this.getList(this.searchFrom)
    cVLlist({}).then(res => {
      this.vehicleL = res
      this.vehicleL.unshift({ id: '', name: '请选择' })
    })
    cVTlist({}).then(res => {
      this.vehicleT = res
      // this.vehicleT.unshift({ id: '', name: '请选择' })
    })
    cVPlist({}).then(res => {
      this.clyt = res
      this.clyt.unshift({ id: '', name: '请选择' })
    })
    cVElist({}).then(res => {
      this.pfbz = res
      this.pfbz.unshift({ id: '', name: '请选择' })
    })
    getRelationCustomerFleet({}).then(res => {
      this.ssdw = JSON.parse(res)
    })
    this.imgfile.append('vhcPhoto1File', '')
    this.imgfile.append('vhcPhoto2File', '')
    this.imgfile.append('params', '')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.lookImgVisible = true
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      CVRlist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 导出车辆列表
    exportFn () {
      // this.loading = true
      let searchFrom = this.searchFrom
      exportExcel(
        this.global.driverName + '/cVehicleRegistration/exportlist',
        searchFrom,
        '车辆登记列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    vehicleSSAddChange (value) {
      this.$set(this.addFrom, 'vhcCompany', '')
      this.$set(this.addFrom, 'vhcCompany1', '')
      this.$set(this.addFrom, 'vhcCompanyName', '')
      this.$set(this.addFrom, 'vhcCompanyCode', '')
    },
    // 导入
    THimportFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/%E8%BD%A6%E8%BE%86%E7%99%BB%E8%AE%B0%E8%A1%A8.xlsx'// 后更改页面地址
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      RimpVehicleInfoExcel(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        this.$message({
          showClose: true,
          message: res,
          duration: 0,
          type: 'success',
          onClose () {
            loading.close()
          }
        })
        that.getList(that.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          duration: 0,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    destroy () {
      this.importDialog = false
    },
    // 图片上传
    handleRemove (file, fileList) {
      console.log(file, fileList)
      if (fileList.length < 1) {
        this.isAddImg = false
      }
      this.addFrom.vhcPhoto1 = ''
      this.listImg = fileList
    },

    imgPreview (file, fileList) {
      console.log(file, fileList)
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/
      if (regex.test(fileName.toLowerCase())) {
        if (fileList.length < 1) {
          this.isAddImg = false
        } else {
          this.isAddImg = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
      this.listImg = fileList
    },
    // 图片上传
    handleRemove1 (file, fileList) {
      console.log(file, fileList)
      if (fileList.length < 1) {
        this.isAddImg1 = false
      }
      this.addFrom.vhcPhoto2 = ''
      this.listImg1 = fileList
    },
    imgPreview1 (file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/
      if (regex.test(fileName.toLowerCase())) {
        if (fileList.length < 1) {
          this.isAddImg1 = false
        } else {
          this.isAddImg1 = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
      this.listImg1 = fileList
    },
    // // 查看图片
    // lookImg (row) {
    //   this.imgUrl = []
    //   if (row.vhcPhoto1 != '') {
    //     this.imgUrl.push(row.vhcPhoto1Url)
    //   }
    //   if (row.vhcPhoto2 != '') {
    //     this.imgUrl.push(row.vhcPhoto2Url)
    //   }
    //   if (this.imgUrl.length == 0) {
    //     this.$alert('该车辆没有上传图片', '系统提示')
    //   } else {
    //     this.lookImgVisible = true
    //   }
    // },
    // 获取车辆信息
    CPHfn () {
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        getCVehicleInfo({ vhcNo: this.addFrom.vhcNo }).then(res => {
          loading.close()
          if (res.id) {
            this.fuzhi(res)
          } else {
            let vhcNo = this.addFrom.vhcNo
            this.addFrom = {
              vhcNo: vhcNo
            }
            this.vhcType = {}
            this.vhcL = {}
            this.listImg = []
            this.listImg1 = []
            this.isAddImg = false
            this.isAddImg1 = false
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 添加
    addVeicle () {
      this.title = '添加'
      this.dialogVisible = true
      this.isAdd = true
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
    },
    // 车辆赋值
    fuzhi (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      if (row.vhcClassify == 1) {
        this.$set(this.addFrom, 'vhcClassify1', [row.vhcClassify, row.vhcNature])
      } else {
        this.$set(this.addFrom, 'vhcClassify1', [row.vhcClassify])
      }
      if (row.vhcTypeId) {
        this.$set(this.addFrom, 'vhcType', { id: row.vhcTypeId, name: row.vhcTypeName })
      }

      if (row.purposeId == -1) {
        this.$set(this.addFrom, 'purpose', row.purposeName)
      } else {
        this.$set(this.addFrom, 'purpose', { id: row.purposeId, name: row.purposeName })
      }
      this.$set(this.addFrom, 'standards', { id: row.standardsId, name: row.standardsName })
      this.vhcL = { id: row.vhcLongId, name: row.vhcLongName }
      if (row.vhcPhoto1 != '') {
        this.$set(this.listImg, 0, { status: 'ready', url: row.vhcPhoto1Url })
        this.isAddImg = true
      } else {
        this.listImg = []
        this.isAddImg = false
      }

      if (row.vhcPhoto2 != '') {
        this.$set(this.listImg1, 0, { status: 'ready', url: row.vhcPhoto2Url })
        this.isAddImg1 = true
      } else {
        this.listImg1 = []
        this.isAddImg1 = false
      }
    },
    // 点击图片放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    // 修改
    modifyVeicle (row) {
      this.fuzhi(row)
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false

      // console.log(row);
      this.carurl = row.vhcLicense1Url
      // console.log(this.carurl);
    },
    saveFn (formName) {
      let that = this
      function img2Fn () {
        console.log(that.addFrom.vhcPhoto2)
        if (!that.addFrom.vhcPhoto2 && that.listImg1.length > 0) {
          compressImage(that.listImg1[0].url, that.listImg1[0].raw, {
            width: 1000
          }).then(result => {
            that.imgfile.set('vhcPhoto2File', result)// result即为压缩后的结果
            that.save1()
          })
        } else {
          that.save1()
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addFrom.vhcClassify = 1
          this.addFrom.vhcCompanyCode = -1
          if (this.addFrom.purpose) {
            if (typeof (this.addFrom.purpose) == 'string') {
              this.addFrom.purposeName = this.addFrom.purpose
              this.addFrom.purposeId = -1
            } else {
              if (this.addFrom.purpose.id == '') {
                this.addFrom.purposeName = null
              } else {
                this.addFrom.purposeName = this.addFrom.purpose.name
              }
              this.addFrom.purposeId = this.addFrom.purpose.id
            }
          }
          if (this.addFrom.standards) {
            if (this.addFrom.standards.id == '') {
              this.addFrom.standardsName = null
            } else {
              this.addFrom.standardsName = this.addFrom.standards.name
            }
            this.addFrom.standardsId = this.addFrom.standards.id
          }

          this.imgfile.set('params', JSON.stringify(this.addFrom))
          let that = this
          if (this.listImg.length > 0 && !this.addFrom.vhcPhoto1) {
            compressImage(this.listImg[0].url, this.listImg[0].raw, {
              width: 1000
            }).then(result => {
              console.log(result)
              that.imgfile.set('vhcPhoto1File', result)// result即为压缩后的结果
              img2Fn()
            })
          } else {
            img2Fn()
          }
        } else {
          return false
        }
      })
    },
    save1 () {
      var that = this
      if (this.isAdd) {
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        CVRadd(that.imgfile).then(res => {
          loading.close()
          that.$message({
            message: '添加成功',
            type: 'success'
          })
          that.dialogVisible = false
          that.getList(that.searchFrom)
        }).catch(error => {
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      } else {
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        cVIupdate(that.imgfile).then(res => {
          loading.close()
          that.$message({
            message: '修改成功',
            type: 'success'
          })
          that.dialogVisible = false
          that.getList(that.searchFrom)
        }).catch(error => {
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 删除
    delVeicle () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据')
      } else {
        var that = this
        this.id = []
        selectData.some(item => {
          that.ids.push(item.id)
        })
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cVIdelete({ ids: this.ids }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },

    closeDialog () {
      this.addFrom = {
      }
      this.vhcType = {}
      this.vhcL = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.imgfile.set('vhcPhoto1File', '')
      this.imgfile.set('vhcPhoto2File', '')
      this.imgfile.set('params', '')
      this.listImg = []
      this.listImg1 = []
      this.isAddImg = false
      this.isAddImg1 = false
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTimes: null,
        registerDates: null
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
          t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    dateFormat1: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
          t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      let str = ''
      if (cellValue) {
        str = t.getFullYear() + '-' + month + '-' + date
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
  .searchBtnBox {
    margin-left: 10px;
  }
  .inpBox .el-date-editor{
    width: 350px!important;
  }
  .imgBox{
    display: flex;
    .item{
      display: flex;
      width: 50%;
      justify-content: space-around;
    }
  }
  .jiaoyan /deep/.el-date-editor {
    width: 150px!important;
  }
  /deep/.jiaoyan .el-date-editor .el-input__inner {
    width: 150px;
  }
  .box{
    display: flex;
    justify-content: space-around;
    .imgBox{
      display: flex;
      flex-direction: column;
      width: 386px;
      /deep/.el-upload--picture-card{
        width: 386px;
        height: 240px;
      }
    }
    h6{
      text-align: center;
    }
    .hidden /deep/.el-upload--picture-card{
      display: none;
    }
    /deep/.el-upload--picture-card {
      background-image: url(../../../assets/images/upload1.png);
    }
    /deep/.el-upload-list--picture-card .el-upload-list__item{
      width: 386px;
      height: 240px;
    }
  }
  .loogImgBox{
    display: flex;
    justify-content: space-around;
    .box1{
      width: 48%;
    }
    img{
      width: 100%;
    }
  }

  /deep/.inpBox .bigInp .el-input__inner{
    width: 250px;
  }
</style>
